import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class CrossXssScriptService {
  constructor(private sanitizer: DomSanitizer) {}

  private readonly xssPattern = /<script\b|javascript:|vbscript:|on\w+\s*=|<iframe\b|<object\b|<embed\b|<svg\b/i;

  sanitize(value: string): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
  }

  hasXss(value: string): boolean {
    if (!value) {
      return false;
    }

    return this.xssPattern.test(value) || this.isModifiedBySanitizer(value);
  }

  /**
   * True when the sanitizer removed or rewrote markup. The sanitizer also entity-encodes harmless characters
   * (newlines, quotes, accents, `&`), so its output is decoded back to text before comparing; otherwise plain
   * multi-line or non-ASCII input would be reported as XSS.
   */
  private isModifiedBySanitizer(value: string): boolean {
    // A textarea parses its content as RCDATA: entities are decoded, tags stay literal and nothing executes.
    const decoder = document.createElement('textarea');
    decoder.innerHTML = this.sanitize(value);
    // The HTML parser normalises CR / CRLF to LF, so the input is normalised the same way.
    return decoder.textContent !== value.replace(/\r\n?/g, '\n');
  }
}
